import { render } from "./AfterSalesProcessForm.vue?vue&type=template&id=247e33a3&scoped=true"
import script from "./AfterSalesProcessForm.vue?vue&type=script&lang=js"
export * from "./AfterSalesProcessForm.vue?vue&type=script&lang=js"

import "./AfterSalesProcessForm.vue?vue&type=style&index=0&id=247e33a3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-247e33a3"],['__file',"src/components/AfterSalesProcessForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "247e33a3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('247e33a3', __exports__)) {
    api.reload('247e33a3', __exports__)
  }
  
  module.hot.accept("./AfterSalesProcessForm.vue?vue&type=template&id=247e33a3&scoped=true", () => {
    api.rerender('247e33a3', render)
  })

}


export default __exports__